import store from "@/store/"
import util from "@/mixins/util";

let Firebase = class {
    constructor(options) {
        this.collectionKeys = options.collectionKeys;
        this.docKeys = options.docKeys;

        let lastRefCount = this.collectionKeys.length;
        if(this.docKeys.length > lastRefCount) {
            lastRefCount = this.docKeys.length;
        }
        let fireRef = store.state.db;
        for (let i = 0; i < lastRefCount; i++) {
            if(!util.isEmpty(this.collectionKeys[i])) {
                fireRef = fireRef.collection(this.collectionKeys[i])
            }
            if(!util.isEmpty(this.docKeys[i])) {
                fireRef = fireRef.doc(this.docKeys[i])
            }
        }

        this.fireRef = fireRef;
    }

    async getList(filterSet) {
        let fireRef = this.fireRef;
        let $this = this;
        let setFilterRef = this.setFilters(filterSet);
        return new Promise(async function (resolve, reject) {
            let data = {
                total: 0,
                list : [],
            }
            data.total = await fireRef.get().then(snap => {
                return snap.size
            });

            //let setFilterRef = $this.setFilters(filterSet);
            setFilterRef = fireRef.orderBy('created', 'desc');
            setFilterRef.onSnapshot(snapshot => {
                snapshot.docChanges().forEach(change => {

                    let msg = change.doc.data();
                    msg.id = change.doc.id;
                    data.list.push(msg);
                });
                resolve(data);

            },function(error) {
                console.log('snapshot error', error);
            });
        })
    }

    setFilters(filterSet) {
        let setFilterRef = this.fireRef;
        let filterList = Object.values(filterSet.filter);
        filterList.forEach(obj => {
            if(obj.hasOwnProperty('query')) {
                //returnParams[obj.key] = obj.query;
            }else if(obj.hasOwnProperty('value')) {
                //returnParams[obj.key] = obj.value;
                setFilterRef = setFilterRef.where(obj.key, '==', obj.value)
            }else if(obj.hasOwnProperty('start') && obj.hasOwnProperty('end')) {
                /*returnParams[obj.key+'sd'] = obj.start;
                returnParams[obj.key+'ed'] = obj.end;*/
                setFilterRef = setFilterRef.where(obj.key, '>=', obj.value)
                setFilterRef = setFilterRef.where(obj.key, '<=', obj.value)
            }
        });
        if(!util.isEmpty(filterSet.sort.key) && !util.isEmpty(filterSet.sort.order)) {
            /*returnParams.orderByType = filterSet.sort.key;
            returnParams.orderBySort = filterSet.sort.order;*/
            setFilterRef = setFilterRef.orderBy(filterSet.sort.key, filterSet.sort.order);
        }else{
            setFilterRef = setFilterRef.orderBy('created', 'desc');
        }

        // let startAt = 1;
        // let endAt = 10;
        // setFilterRef = setFilterRef.startAt(startAt).endAt(endAt);
        return setFilterRef;
    }
}

export default Firebase;
